var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLove(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3613 28.8881L14.7593 28.5483C14.3729 28.3299 5.25733 23.129 2.15542 16.4641C0.375366 12.6386 0.434718 8.59415 2.31475 5.64551C3.7466 3.40013 6.09856 2.1123 8.76758 2.1123C12.0808 2.1123 14.1716 4.10181 15.3613 6.20527C16.551 4.10234 18.6423 2.11283 21.955 2.11283C24.624 2.11283 26.9765 3.40066 28.4078 5.64656C30.2881 8.59468 30.3472 12.6386 28.5671 16.4641C25.4655 23.129 16.35 28.3299 15.9632 28.5483L15.3613 28.8881ZM8.76758 4.56186C6.92554 4.56186 5.36733 5.41443 4.38023 6.96288C2.95259 9.20193 2.95101 12.3674 4.37653 15.43C6.72268 20.4716 13.3277 24.8083 15.3608 26.0555C17.3935 24.8072 24.0041 20.4626 26.346 15.43C27.7715 12.3674 27.77 9.20245 26.3423 6.9634C25.3552 5.41496 23.7973 4.56239 21.955 4.56239C17.5375 4.56239 16.5779 9.87512 16.5684 9.92893L15.3613 16.9874L14.1539 9.92893C14.1157 9.71315 13.1536 4.56186 8.76758 4.56186Z",
    fill: "#C10021"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3615 27.4811C15.3615 27.4811 6.23781 22.3319 3.26621 15.9466C0.294618 9.5613 3.26621 3.33691 8.76782 3.33691C14.2694 3.33691 15.3615 9.72222 15.3615 9.72222C15.3615 9.72222 16.4536 3.33744 21.9552 3.33744C27.4568 3.33744 30.4287 9.5613 27.4568 15.9466C24.4855 22.3319 15.3615 27.4811 15.3615 27.4811Z",
    fill: "url(#paint0_linear_2093_6871)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.52575 7.95764C4.72517 5.42051 7.70389 5.21528 8.7485 6.91303C9.79311 8.61079 4.22107 11.8322 4.52575 7.95764Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M15.54 24.3703C17.2578 24.3703 25.9876 19.277 25.9876 15.4025C25.9876 11.5279 23.0706 12.0065 20.5024 16.4033C17.9341 20.8002 16.2796 22.3244 15.1044 22.7596C13.9293 23.1949 14.3645 24.3703 15.54 24.3703Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2093_6871",
    x1: 15.3613,
    y1: -0.320272,
    x2: 15.3613,
    y2: 24.168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509091,
    stopColor: "#FF1F3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661493,
    stopColor: "#FF2243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.816528,
    stopColor: "#FF2C4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972337,
    stopColor: "#FF3C64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3F68"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLove);
export default __webpack_public_path__ + "static/media/Love.ddc2c439d02891e8a714334db55bdbd6.svg";
export { ForwardRef as ReactComponent };